// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__15Bsp","header":"PatientBlock_header__vA2i9","label":"PatientBlock_label__37HFl","option":"PatientBlock_option__1aMeq"};